import { Component, EventEmitter, Inject, OnInit, Output, viewChild } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { ErrorRequestModel, ResponseRequestModel } from '../../../core/models/response.model'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { LocationService } from '../../../core/services/location/location/location.service'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { ServiceSpecificationService } from '../../../core/services/service/service-specification/service-specification.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker'
import { provideNgxMask } from 'ngx-mask'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { ModalSupplierComponent } from '../../person/supplier/modal_supplier/modal-supplier.component'
import moment from 'moment/moment'
import { convertCurrency, removeAccents } from '../../../shared/utils/utils'
import { MatExpansionModule } from '@angular/material/expansion'
import { map, Observable, startWith, Subscription } from 'rxjs'
import { OnDestroy } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListTariffComponent } from '../../../shared/components/table-list-tariff/table-list-tariff.component'
import { DialogChooseComponent } from '../../../shared/components/dialog-to-choose/dialog-to-choose.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { CommonModule } from '@angular/common'
import { ModalLocationCreateComponent } from '../../location/modal-location-create/modal-location-create.component'
import { MatTooltip } from '@angular/material/tooltip'
import { DialogChooseUniqueComponent } from '../../../shared/components/dialog-to-choose-unique/dialog-to-choose-unique.component'
import { ModalLegalEntityClientSubNewComponent } from '../../customer/modal_client/modal-legal-entity-client-sub-new/modal-legal-entity-client-sub-new.component'

interface LocationModel {
  id: number
  descricao: string
  cidade: string
  estado: string
}

@Component({
  selector: 'tariff-create',
  imports: [
    CommonModule,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatSlideToggle,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    CurrencyInputDirective,
    MatExpansionModule,
    MatProgressBar,
    PaginationComponent,
    /* TableListTariffSelectComponent, */
    TableListTariffComponent,
    MatAutocompleteModule,
    MatTooltip,
  ],
  templateUrl: './tariff-create.component.html',
  styleUrl: './tariff-create.component.scss',
  providers: [
    TariffService,
    TariffTypeService,
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class TariffCreateComponent implements OnInit, OnDestroy {
  constructor(
    private formBuilder: FormBuilder,
    private tariffService: TariffService,
    private tariffTypeService: TariffTypeService,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private vehicleTypeService: VehicleTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<TariffCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data && data.user) {
      this.item = { user: true, data: data.item }
    }
  }

  private subscriptions = new Subscription()

  datepicker = viewChild<MatDatepicker<any>>('birth')
  @Output() responseEdit = new EventEmitter()

  filteredOrigins!: Observable<LocationModel[]>
  filteredDestinations!: Observable<LocationModel[]>
  displayLocation = (loc: LocationModel | null): string =>
    loc ? `${loc.cidade} - ${loc.estado}` : ''

  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  formAverage: FormGroup = new FormGroup({})

  loading: boolean = false

  listTypeTariff: any[] = []
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listServiceSpecification: any[] = []

  clientSelected: any = {}
  supplierSelected: any = {}

  columns: any[] = [
    {
      keyColumn: 'typeTariff',
      // key: 'tipo',
      key: 'tipoTarifario',
      description: 'Tipo',
    },
    {
      keyColumn: 'location_OD',
      key: 'origem',
      description: 'Trecho',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'cost',
      key: 'custo_formatado',
      description: 'Custo',
    },
    {
      keyColumn: 'custoExtra_HK',
      key: 'custo_formatado',
      description: 'Custo Extra',
    },
    {
      keyColumn: 'infoTariff',
      key: 'perimetroUrbano',
      description: 'Infos',
    },
    {
      keyColumn: 'supplier',
      key: 'fornecedor',
      description: 'Fornecedor',
    },
    {
      keyColumn: 'validity',
      key: 'dataValidade',
      description: 'validade',
    },
  ]

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loadingTable: boolean = false
  subClient: boolean = false

  ngOnInit(): void {
    this.getTypeTariff()
    this.getLocation()
    this.getTypeService()
    this.getTypeVehicle()
    this.getTypeDriver()
    this.createForm()
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }

  getTypeTariff() {
    this.tariffTypeService.listTariffType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeTariff = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getLocation() {
    this.locationService.listLocation().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listLocation = response.data
        this.initOriginFilter()

        const originItem = this.listLocation.find((c) => c.id === this.item.origemId)
        const destinationItem = this.listLocation.find((c) => c.id === this.item.destinoId)

        if (originItem) {
          this.form.get('origin')!.setValue(originItem)
        }
        if (destinationItem) {
          this.form.get('destination')!.setValue(destinationItem)
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  private initOriginFilter(): void {
    this.filteredOrigins = this.form.get('origin')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        // Converte para string (tratando objetos LocationModel)
        if (typeof v === 'string') return v
        if (v && typeof v.cidade === 'string' && typeof v.estado === 'string')
          return `${v.cidade} - ${v.estado}`
        if (v && typeof v.descricao === 'string') return v.descricao
        return ''
      }),
      map((text) => removeAccents(text.toLowerCase())),
      map((searchText) => {
        return this.listLocation.filter((loc) => {
          const locDescription = loc?.descricao || ''
          const locCity = loc?.cidade || ''
          const locState = loc?.estado || ''
          const searchData = `${locDescription} ${locCity} ${locState}`
          return removeAccents(searchData.toLowerCase()).includes(searchText)
        })
      }),
    )

    this.filteredDestinations = this.form.get('destination')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        if (typeof v === 'string') return v
        if (v && typeof v.cidade === 'string' && typeof v.estado === 'string')
          return `${v.cidade} - ${v.estado}`
        if (v && typeof v.descricao === 'string') return v.descricao
        return ''
      }),
      map((text) => removeAccents(text.toLowerCase())),
      map((searchText) => {
        return this.listLocation.filter((loc) => {
          const locDescription = loc?.descricao || ''
          const locCity = loc?.cidade || ''
          const locState = loc?.estado || ''
          const searchData = `${locDescription} ${locCity} ${locState}`
          return removeAccents(searchData.toLowerCase()).includes(searchText)
        })
      }),
    )
  }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  onSelectionChangeServiceSpecification(event: MatSelectChange) {
    this.form.get('specificationService')!.setValue('')
    if (event.value >= 0) {
      this.getServiceSpecification(event.value)
    }
  }

  getServiceSpecification(idType: number) {
    this.listServiceSpecification = []
    this.serviceSpecificationService.listServiceSpecificationByType(idType).subscribe({
      next: (response: ResponseRequestModel) => {
        this.listServiceSpecification = response.data ?? []
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  createTariff() {
    this.loading = true
    const model = this.createModel()
    this.tariffService.createTariff(model).subscribe({
      next: (response: ResponseRequestModel) => {
        if (response.statusCode == 419) {
          this.dialogChooseStandard(model, response.data.IdOldTarrif)
        } else if (response.statusCode == 409) {
          this.dialogChooseUnique(model)
        } else {
          this.snackbar.success(response.message)
          // this.responseEdit.emit(true)
          // this.close()
          this.dialogChoose()
        }
      },
      error: (err: any) => {
        if (err.error.statusCode == 409) {
          this.dialogChooseUnique(model)
          // this.snackbar.error(err.error.data.message)
          // this.dialogChooseStandard(model, err.error.data.id)
        } else {
          this.snackbar.errorRequest(err)
        }
        this.loading = false
      },
      complete: () => {
        this.loading = false
        // this.form.reset()
      },
    })
  }

  createTariffStandard(model: any, IdOldTarrif: string) {
    this.loading = true
    this.tariffService.createTariffStandard({ oldStandardId: IdOldTarrif, tarifario: model }).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        // this.responseEdit.emit(true)
        // this.close()
        this.dialogChoose()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.form.reset()
      },
    })
  }

  createTariffUnique(model: any) {
    this.loading = true
    this.tariffService.createTariffUnique(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        // this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.form.reset()
      },
    })
  }

  validClient() {
    if (this.form.get('tariffType')!.value == 1 && !this.clientSelected.id) {
      return true
    } else if (this.form.get('tariffType')!.value == 2 && this.clientSelected.id) {
      return true
    } else if (this.form.get('tariffType')!.value > 2) {
      return true
    } else {
      return false
    }
  }

  checkOrigin() {
    let origin = this.form.get('origin')!.value
    if (origin && origin.id) {
      return true
    } else {
      return false
    }
  }

  checkDestination() {
    this.form.get('destination')!.value
    let destination = this.form.get('destination')!.value
    if (destination && destination.id) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    if (this.form.valid && this.validClient() && this.checkOrigin() && this.checkDestination()) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    const origin = this.form.get('origin')!.value
    const destination = this.form.get('destination')!.value
    const model = {
      tipoId: this.form.get('tariffType')!.value,
      origemId: origin?.id,
      destinoId: destination?.id,
      tipoServicoId: this.form.get('serviceType')!.value,
      servicoId: this.form.get('specificationService')!.value.id,
      tipoVeiculoId: this.form.get('vehicleType')!.value != '' ? this.form.get('vehicleType')!.value : 0,
      tipoMotoristaId: this.form.get('driverType')!.value != '' ? this.form.get('driverType')!.value : 0,
      clienteId: this.clientSelected.id ? this.clientSelected.id : 0,
      fornecedorId: this.supplierSelected.id ? this.supplierSelected.id : 0,
      custo: convertCurrency(this.form.get('cost')!.value),
      custoHoraExtra: convertCurrency(this.form.get('costOvertime')!.value),
      custoKmExtra: convertCurrency(this.form.get('costKmExtra')!.value),
      ativo: 'S',
      dataValidade: moment(this.form.get('validity')!.value).format('DD/MM/YYYY'),
      perimetroUrbano: this.form.get('urbanPerimeter')!.value ? 'S' : 'N',
      // standard: this.form.get('standard')!.value ? 'S' : 'N',
      standard: 'N',
    }
    return model
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      tariffType: [1, [Validators.required]],
      serviceType: ['', [Validators.required]],
      specificationService: ['', [Validators.required]],
      vehicleType: [''],
      driverType: [''],
      origin: ['', [Validators.required]],
      destination: ['', [Validators.required]],
      cost: ['', [Validators.required]],
      costOvertime: ['', [Validators.required]],
      costKmExtra: ['', [Validators.required]],
      validity: ['', [Validators.required]],
      // active: [''],
      client: [''],
      supplier: [''],
      // standard: [false],
      urbanPerimeter: [true],
    })
    this.formAverage = this.formBuilder.group({
      averageCost: [''],
      averageOvertime: [''],
      averageKmExtra: [''],
    })
    this.formAverage.get('averageCost')!.disable()
    this.formAverage.get('averageOvertime')!.disable()
    this.formAverage.get('averageKmExtra')!.disable()

    if (this.item.user) {
      this.clientSelected = this.item.data
      this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
      this.form.get('tariffType')!.setValue(2)
      this.form.get('tariffType')!.disable()
      this.form.get('client')!.disable()
    } else {
      this.form.get('client')!.disable()
    }
    this.form.get('vehicleType')!.disable()
    this.form.get('driverType')!.disable()
    this.monitoringInputs()
  }

  monitoringInputs() {
    this.form.valueChanges.subscribe((value) => {
      this.page = 1
      this.filterTariff()
    })
  }

  filterTariff() {
    // if (this.checkSearch() && this.loadingTable == false) {
    //   this.loadingTable = true
    //   this.tariffService
    //     .searchPagedTariff(this.page, this.rows, this.modelSearch())
    //     .subscribe({
    //       next: (response: ResponseRequestModel) => {
    //         this.treatResponse(response)
    //         this.loadingTable = false
    //       },
    //       error: (err: ErrorRequestModel) => {
    //         this.snackbar.errorRequest(err)
    //         this.loadingTable = false
    //       },
    //       complete: () => {
    //         this.loadingTable = false
    //       },
    //     })
    // }
  }

  checkSearch() {
    if (
      this.form.get('serviceType')?.value != '' &&
      this.form.get('specificationService')?.value.id != '' &&
      this.form.get('origin')?.value != '' &&
      this.form.get('destination')?.value != ''
    ) {
      if (this.form.get('tariffType')?.value == 2 && this.form.get('client')?.value == '') {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }

  modelSearch() {
    return {
      origemId:
        this.form.get('origin')!.value && this.form.get('origin')!.value.id ? this.form.get('origin')!.value.id : 0,
      origem: '',
      destinoId:
        this.form.get('destination')!.value && this.form.get('destination')!.value.id
          ? this.form.get('destination')!.value.id
          : 0,
      destino: '',
      tipoServicoId: this.form.get('serviceType')!.value != '' ? this.form.get('serviceType')!.value : 0,
      tipoServico: '',
      servicoId:
        this.form.get('specificationService')!.value != '' ? this.form.get('specificationService')!.value.id : 0,
      servico: '',
      tipoVeiculoId: this.form.get('vehicleType')!.value != '' ? this.form.get('vehicleType')!.value : 0,
      tipoVeiculo: '',
      tipoMotoristaId: this.form.get('driverType')!.value != '' ? this.form.get('driverType')!.value : 0,
      tipoMotorista: '',
      clienteId: this.form.get('tariffType')!.value != 1 ? this.clientSelected.id : 0,
      cliente: '',
      fornecedorId: 0,
      fornecedor: '',
      perimetroUrbano: this.form.get('urbanPerimeter')!.value == true ? 'S' : 'N',
      // standard: 'T',
      standard: 'N',
      // standard: this.form.get('standard')!.value ? 'S' : 'N',
    }
  }

  onSelectionChangeService(event: MatSelectChange) {
    const specificationService = event.value
    if (specificationService) {
      if (specificationService.exigeVeiculo && specificationService.exigeVeiculo.toLowerCase() == 's') {
        this.form.get('vehicleType')!.setValidators(Validators.required)
        this.form.get('driverType')!.setValidators(Validators.required)
        this.form.get('vehicleType')!.enable()
        this.form.get('driverType')!.enable()
      } else {
        this.form.get('vehicleType')!.clearValidators()
        this.form.get('driverType')!.clearValidators()
        this.form.get('vehicleType')!.disable()
        this.form.get('driverType')!.disable()
      }
    }
  }

  onSelectionChangeTypeTarrif(event: MatSelectChange) {
    if (event.value == 1) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
      this.form.get('client')!.disable()
    } else {
      this.form.get('client')!.enable()
    }
  }

  addSupplier() {
    const dialogRef = this.dialog.open(ModalSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.supplierSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.supplierSelected = response.selection
          this.form.get('supplier')!.setValue(this.supplierSelected.nomeFantasia)
        } else {
          this.supplierSelected = {}
          this.form.get('supplier')!.setValue('')
        }
      }
    })
  }

  addClient() {
    // const dialogRef = this.dialog.open(
    //   ModalLegalEntityClientSubClientComponent,
    //   {
    const dialogRef = this.dialog.open(ModalLegalEntityClientSubNewComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        subClient: this.subClient,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.clientSelected = response.selection
          this.subClient = response.subClient
          this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
        } else {
          this.clientSelected = {}
          this.form.get('client')!.setValue('')
        }
      }
    })
  }

  openDatepicker() {
    this.datepicker()?.open()
  }

  treatResponse(response: any) {
    const list = []
    let averageCost = 0
    let averageKmExtra = 0
    let averageOvertime = 0
    if (response.data) {
      for (const item of response.data.tarifarios) {
        list.push({
          ...item,
          custo_formatado: `R$ ${convertCurrency(item.custo)}`,
          custoHoraExtra_formatado: `R$ ${convertCurrency(item.custoHoraExtra)}`,
          custokmExtra_formatado: `R$ ${convertCurrency(item.custokmExtra)}`,
          fornecedor: item.fornecedor ?? ' - ',
          tipo: item.tipoId == '1' ? 'tg.mob' : 'Cliente',
        })
      }
      if (response.data.medias) {
        averageCost = response.data.medias.custo ?? 0
        averageKmExtra = response.data.medias.km ?? 0
        averageOvertime = response.data.medias.hora ?? 0
      }
    }

    this.formAverage.get('averageCost')!.setValue(convertCurrency(averageCost))
    this.formAverage.get('averageKmExtra')!.setValue(convertCurrency(averageKmExtra))
    this.formAverage.get('averageOvertime')!.setValue(convertCurrency(averageOvertime))

    this.itemsList = list
    this.numberRows = response.totalItens
  }

  pageChanged(page: number) {
    this.page = page
    this.filterTariff()
  }

  dialogChoose() {
    const dialogRef = this.dialog.open(DialogChooseComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: 'Deseja criar outro tarifário?',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response == true) {
        this.filterTariff()
      } else {
        this.responseEdit.emit(true)
        this.close()
      }
    })
  }

  dialogChooseUnique(model: any) {
    const dialogRef = this.dialog.open(DialogChooseUniqueComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: '',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.createTariffUnique(model)
      }
    })
  }

  dialogChooseStandard(model: any, IdOldTarrif: string) {
    const dialogRef = this.dialog.open(DialogChooseComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: 'Já existe um tarifário standard, deseja criá-lo como standard?',
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response == true) {
        this.createTariffStandard(model, IdOldTarrif)
      }
    })
  }

  createLocation() {
    const dialogRef = this.dialog.open(ModalLocationCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '1000px',
      maxWidth: '1000px',
      maxHeight: '620px',
      data: {},
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      if (response) {
        this.getLocation()
      }
    })
  }
}
